import React, { useEffect, useState } from 'react';
import { useTitle } from '../HooksPublic';
import { Button, Groupper, Header, Image } from 'react-frontier';
import { Link } from 'react-router-dom';
import API from '../APIPublic';
import { CDN_URL, PLACEHOLDER_IMG } from '../ConfigPublic';
import { PublicCareer } from '../ClassesPublic';

import '../style/work_with_us.scss';

var WorkWithUs = ()=>{
	var { setTitle } = useTitle();
	var [careers, setCareers] = useState<PublicCareer[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setTitle('COCOAN - Trabaja con nosotros', false);
		API.getCareers().then(res=>{
			if(res.error) return setLoadError(res.message);
			setCareers(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error al cargar las vacantes.');
		});
	}, []);

	return <div className='co work-with-us-screen'>
		<div className='work-hero'>
			<img src={`${CDN_URL}/static/work_with_us/BANNER_TRABAJO.webp`} alt='Bolsa de trabajo' className='hero-bg' />
			<div className="hero-overlay">
				<h1>Bolsa de <span className="font-homemade">trabajo</span></h1>
			</div>
		</div>
		<div className='main-container'>
			
			<div className="intro-text">
				<p>Buscamos personas apasionadas que quieran crecer con nosotros,<br/>encuentra la vacante ideal para tí.</p>
				<p>Bienvenido a COCOAN.</p>
			</div>
			{loadError ? (
				<Header text='Error' subtext={loadError} />
			) : !careers ? (
				<Header loading text='Cargando vacantes' />
			) : careers.length === 0 ? (
				<Header text='Sin vacantes disponibles' subtext='No hay vacantes disponibles en este momento, vuelve pronto.' />
			) : (
				<div className='careers-grid'>
					{careers.map(c=>(
						<Link key={c.career_id} className='career-card' to={`/vacantes/${c.career_id}`}>
							<div className='career-img' style={{ backgroundImage: `url(${c.image || PLACEHOLDER_IMG})` }}></div>
							<div className='career-info'>
								<h3>{c.title}</h3>
								<p>Sucursal</p>
							</div>
						</Link>
					))}
				</div>
			)}
		</div>
	</div>;
};

export default WorkWithUs;
